export default "__VITE_ASSET__CbyOh$3J__"